import React from 'react'
import Box from '@mui/material/Box'
import Skeleton from '@mui/material/Skeleton'
import Stack from '@mui/material/Stack'
import Paper from '@mui/material/Paper'

function MultiTenantDrawerSkeleton() {
  return (
    <>
      {Array.from({ length: 3 }).map((_, index) => (
        <Stack
          key={index}
          sx={{
            px: 2.4,
            pt: 0.8,
            pb: 1.1,
            borderBottom: 1,
            borderColor: 'divider',
          }}
        >
          {/* Name and Company Link */}
          <Skeleton variant="text" width="60%" height={24} sx={{ mb: 0.4 }} />

          {/* Address */}
          <Skeleton variant="text" width="80%" height={20} />

          {/* Phone and Location Link Row */}
          <Stack
            direction="row"
            justifyContent="space-between"
            alignItems="center"
          >
            <Skeleton variant="text" width="40%" height={22} />
            <Skeleton variant="text" width="25%" height={22} />
          </Stack>

          {/* Entity Type Paper */}
          <Paper
            variant="outlined"
            sx={{
              mt: 0.8,
              px: 1.2,
              pt: 1.2,
              pb: 1.6,
              display: 'flex',
              flexDirection: 'column',
            }}
          >
            <Skeleton variant="text" width="30%" height={24} sx={{ mb: 0.8 }} />
            <Skeleton variant="text" width="50%" height={20} />
          </Paper>

          {/* Buttons Row */}
          <Box
            mt={0.8}
            sx={{
              display: 'flex',
              flexDirection: 'row',
              justifyContent: 'space-between',
              alignItems: 'center',
              width: '100%',
              gap: 0.8,
            }}
          >
            <Skeleton
              variant="rectangular"
              width="48%"
              height={36}
              sx={{ borderRadius: 1 }}
            />
            <Skeleton
              variant="rectangular"
              width="48%"
              height={36}
              sx={{ borderRadius: 1 }}
            />
          </Box>
        </Stack>
      ))}
    </>
  )
}

export default MultiTenantDrawerSkeleton
